$(function() {
	// hosts comparison description copy
	$('.comparison-hosts td.row-note').each(function() {
		var $note = $(this),
			$tr = $note.closest('tr'),
			$copy = $('<tr/>', {
				'class': 'visible-small',
				'aria-hidden': true
			}).append($('<td/>').text('&nbsp;')).append($('<td/>', {
				'colspan': 6,
				'class': 'row-note'
			}).text($note.text()));

		$tr.before($copy);
	});
});